module.exports = {
    "small"    : 670,
    "medium"   : 768,
    "x-medium"   : 992,
    "xx-medium" : 1024,
    "menu"     : 1250,
    "large"    : 1440,
    "x-large"  : 1920,
    "xx-large" : 2560
}